<mat-expansion-panel [disabled]="flujosPJ.configuracionProducto.bloqueado" hideToggle
                     [expanded]=" flujosPJ.datosEmpresa.ok && !flujosPJ.configuracionProducto.ok && !flujosPJ.configuracionProducto.cargando ">
  <mat-expansion-panel-header>
    <mat-panel-title> {{requiereProveedorServicio ? 'Selecciona una empresa experta' : 'Configuración de tu
      producto'}}  </mat-panel-title>
    <mat-panel-description>
      <div
           *ngIf=" flujosPJ.datosEmpresa.ok && !flujosPJ.configuracionProducto.cargando && !flujosPJ.configuracionProducto.ok && (showCantidadCampos || cantidadCamposEditables > 0) ">
        <!--======informacion menu ======--> {{ labelCampos }}
      </div>
      <div *ngIf="flujosPJ.configuracionProducto.cargando">
        <div class="spinner-border text-light" role="status"> <span class="sr-only">Loading...</span> </div>
      </div>
      <div *ngIf=" flujosPJ.configuracionProducto.ok && !flujosPJ.configuracionProducto.cargando ">
        <!--======ok menu ======--> <img src="assets/icons/icon-check.svg" alt="ok" />
      </div>
    </mat-panel-description>
  </mat-expansion-panel-header>
  <ng-container *ngIf=" !flujosPJ.configuracionProducto.cargando && flujosPJ.configuracionProducto.mostrar ">
    <div *ngIf="!requiereProveedorServicio" class="row">
      <div class="col-md-12">
        <p class="producto-seleccionado"> Tu producto seleccionado: <strong> {{ producto.title }}</strong> </p>
      </div>
    </div> <!-- Ingresa URL -->
    <ng-container *ngIf="requiereURL">
      <div class="row ingresa-url" [formGroup]="urlFormOpcional">
        <div class="col-md-6"> <span class="prefijo">www.</span> <label for="url">Dirección web de tu empresa
            (URL) (opcional)</label> <input [readOnly]="!edicion" type="text" name="url" formControlName="url"
                 placeholder="miempresa.com" class="pre-input" appMaxLength="96" autocomplete="off"
                 [class.inputInvalido]=" urlFormOpcional.get('url').invalid && (urlFormOpcional.get('url').touched || urlFormOpcional.get('url').dirty) " />
          <p *ngIf=" ((urlFormOpcional.get('url').touched || urlFormOpcional.get('url').dirty) && urlFormOpcional.get('url') === null) || ((urlFormOpcional.get('url').touched || urlFormOpcional.get('url').dirty) && urlFormOpcional.get('url').invalid) "
             class="mensajeError"> {{ mensajesConfiguracionProductoPJ.REQUIRED_URL_MESSAGE }} </p>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="requiereURLObligatorio">
      <div class="row ingresa-url" [formGroup]="urlFormObligatorio">
        <div class="col-md-6"> <span class="prefijo">www.</span> <label for="url">Dirección web de tu empresa
            (URL)</label> <input [readOnly]="!edicion" type="text" name="url" formControlName="url"
                 placeholder="miempresa.com" class="pre-input" autocomplete="off" appMaxLength="96"
                 [class.inputInvalido]=" urlFormObligatorio.get('url').invalid && (urlFormObligatorio.get('url').touched || urlFormObligatorio.get('url').dirty) " />
          <p *ngIf=" ((urlFormObligatorio.get('url').touched || urlFormObligatorio.get('url').dirty) && urlFormObligatorio.get('url') === null) || ((urlFormObligatorio.get('url').touched || urlFormObligatorio.get('url').dirty) && urlFormObligatorio.get('url').invalid) "
             class="mensajeError"> {{ mensajesConfiguracionProductoPJ.REQUIRED_URL_MESSAGE }} </p>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="requiereProveedorServicio">
      <div [formGroup]="proveedorServicio">
        <app-configura-proveedor-servicio-tecnologico
            (selectPSTEvent)="selectPST($event)" [selectedPST]="idProveedor"></app-configura-proveedor-servicio-tecnologico>
    </div>
  </ng-container>

    <app-configura-producto-compartido [requiereContacto]="requiereContacto" [requiereTecnico]="requiereTecnico"
                                       [edicion]="edicion" [configProdTransbank]="configProdTransbank"
                                       [configProdIndependiente]="configProdInd" [configProductos]="configProductos"
                                       [mensajeErrorConfiguracionProducto]="mensajesConfiguracionProductoPJ"
                                       [requiereNombreLinkPago]="requiereNombreLinkPago" [conLimite]="conLimite"
                                       [yoRecibo]="yoRecibo" [autocomplete]="preFill" [onOff]="onOff"
                                       [messageRutError]="messageRutError" (yoReciboBtn)="yoReciboBtn()"
                                       (otraPersonaBtn)="otraPersonaBtn()" (on)="on()" (off)="off()">
    </app-configura-producto-compartido>

    <ng-container
                  *ngIf="validacionCaso === 'PACK_VENTA_MPOS_LP_GARANTIA' || validacionCaso === 'LINK_PAGO' || validacionCaso === 'PACK_VENTA_MPOS_LP' || validacionCaso === 'PACK_POS_MOVIL_LP'">
      <div class="row box-button">
        <div class="col-md-12"> <button class="btn-primary-tbk" type="button" (click)="guardarConfiguracionProducto()"
                  value="Guardar"
                  [disabled]=" configProductos.invalid || ((configProductos.get('rangoHasta')?.value || '').length === 0 && conLimite) ">
            <div *ngIf="loading" class="spinner-border text-light" role="status"> <span
                    class="sr-only">Loading...</span> </div>
            <div *ngIf="!loading">Guardar</div>
          </button> </div>
      </div>
    </ng-container>
    <ng-container *ngIf="validacionCaso === 'CREACION_SITIO_ALIANZA_WIX'">
      <div class="row box-button">
        <div class="col-md-12"> <button class="btn-primary-tbk" type="button" (click)="guardarConfiguracionProducto()"
                  value="Guardar" [disabled]="!urlFormOpcional.valid">
            <div *ngIf="loading" class="spinner-border text-light" role="status"> <span
                    class="sr-only">Loading...</span> </div>
            <div *ngIf="!loading"> {{ urlFormOpcional.get("url").value === "" ? "Continuar" : "Guardar" }}
            </div>
          </button> </div>
      </div>
    </ng-container>
    <ng-container *ngIf="validacionCaso === 'INTEGRADOR_TRANSBANK'">
      <div class="row box-button">
        <div class="col-md-12"> <button class="btn-primary-tbk" type="button" (click)="ContinuarGuardar($event)"
                  value="Guardar" [disabled]="!urlFormObligatorio.valid || !configProdTransbank.valid">
            <div *ngIf="loading" role="status" class="spinner-border text-light"> <span
                    class="sr-only">Loading...</span> </div>
            <div *ngIf="!loading" class="ng-none">Guardar</div>
          </button></div>
      </div>
    </ng-container>
    <ng-container *ngIf="validacionCaso === 'INTEGRADOR_CLIENTE'">
      <div class="row box-button">
        <div class="col-md-12"> <button class="btn-primary-tbk" type="button" (click)="ContinuarGuardar($event)"
                  value="Guardar" [disabled]=" !urlFormObligatorio.valid || !configProdInd.valid ">
            <div *ngIf="loading" role="status" class="spinner-border text-light"> <span
                    class="sr-only">Loading...</span></div>
            <div *ngIf="!loading">Guardar</div>
          </button> </div>
      </div>
    </ng-container>
    <ng-container *ngIf="'CREACION_SITIO_PST' === validacionCaso">
      <div class="row box-button">
        <div class="col-md-12"> <button class="btn-primary-tbk" type="button"
                (click)="guardarConfiguracionProducto()" value="Continuar" [disabled]="!idProveedor">
                <div *ngIf="loading" class="spinner-border text-light" role="status"> <span
                        class="sr-only">Loading...</span> </div>
                <div *ngIf="!loading"> Continuar
                </div>
            </button> </div>
    </div>
  </ng-container>
  </ng-container>
</mat-expansion-panel>